<template>
  <div class="bread-main">
    <a-breadcrumb>
      <template v-for="item in state.list">
        <a-breadcrumb-item>{{ item.meta.title }}</a-breadcrumb-item>
      </template>
    </a-breadcrumb>
  </div>
</template>

<script setup>
import {onMounted, reactive, computed, watch} from "vue";
import {useRoute, useRouter} from "vue-router";

const route = useRoute()
const router = useRouter()

const state = reactive({
  list: [], // 面包屑列表
})

// 获取路由列表
const getBreadList = () => {
  let _list = []

  let _routeList = router.getRoutes()
  let _pathList = route.path.split('/').filter(Boolean)

  _pathList.map((item, index) => {
    let _path = `/${_pathList.slice(0, index + 1).join('/')}`
    let _item = _routeList.find(v => v.path === _path)
    if (_item) {
      _list.push(_item)
    }
  })

  state.list = _list
}

watch(() => route.path, (newPath, oldPath) => {
  getBreadList()
}, {deep: true, immediate: true});

onMounted(() => {
})

</script>
<style lang="less" scoped>
.bread-main {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>